import * as formWizardConstants from './constants';
import 'element-closest-polyfill';

/**
 * Gets the action associated with an element
 *
 * @param {Element} element
 */
export default function getAction(el) {
  if (el) { return el.closest(formWizardConstants.selectors.action); }
}
